import { render } from "./Next.vue?vue&type=template&id=96d22eca"
const script = {}

import exportComponent from "/Users/dominik/Development/Websites/elite-partner.gui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__